'use es6';

import { getComputedMargin } from 'layout-dnd-utils/dom/margin';
import { getGridNodeElementSelector } from 'layout-dnd-utils/grids/render/domSelectors';
export const getDndAreaComputedMargin = dndAreaElement => {
  const computedMargin = getComputedMargin(dndAreaElement);
  return computedMargin;
};
export const getDndAreaElement = id => {
  const dndAreaElement = document.getElementById(`dnd-grid-${id}`);
  if (!dndAreaElement) {
    throw new Error(`Could not find DnD area element with id ${id}`);
  }
  return dndAreaElement;
};
export const getGridNodeElement = (node, parentElement = document) => {
  const gridContentElement = parentElement.querySelector(getGridNodeElementSelector(node));
  if (!gridContentElement) {
    console.warn(`Could not find grid content element of ${node.getType()} with id ${node.getId()}`);
  }
  return gridContentElement;
};
export const getGridLayoutTreeElement = (node, parentElement) => {
  // TODO: Add delegated bounds support
  return [getGridNodeElement(node, parentElement)];
};